import { render } from "./DashboardSpaceTimeSeriesGraph.vue?vue&type=template&id=1457b41d&scoped=true"
import script from "./DashboardSpaceTimeSeriesGraph.vue?vue&type=script&lang=js"
export * from "./DashboardSpaceTimeSeriesGraph.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1457b41d"
/* hot reload */
if (module.hot) {
  script.__hmrId = "1457b41d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1457b41d', script)) {
    api.reload('1457b41d', script)
  }
  
  module.hot.accept("./DashboardSpaceTimeSeriesGraph.vue?vue&type=template&id=1457b41d&scoped=true", () => {
    api.rerender('1457b41d', render)
  })

}

script.__file = "src/components/dashboard/DashboardSpaceTimeSeriesGraph.vue"

export default script